// The one open sheet (dialog), by kind.
import { ProLock } from '../components/ProLock.tsx';
import { Sheet } from '../components/common.tsx';
import { useStore } from '../store/hooks.tsx';
import { AddDeviceSheet } from './Devices.tsx';
import { EntryEditor } from './EntryEditor.tsx';
import { ExportSheet, InvoiceSheet, ReportPrintSheet } from './Exports.tsx';
import { ProjectEditor } from './ProjectEditor.tsx';
import { SearchSheet } from './Search.tsx';
import { SpanEdit } from './SpanEdit.tsx';

export function Sheets() {
  const store = useStore();
  const sheet = store.sheet;
  if (!sheet) return null;
  // Customer-ready PDFs and invoices are Pro (spec/pro.md), whichever way the sheet was asked for.
  if ((sheet.kind === 'invoice' || sheet.kind === 'reportPrint') && !store.pro) {
    return <Sheet title="Tellary Pro" onClose={() => store.closeSheet()}><ProLock text={store.t('Leistungsnachweise und Rechnungen gibt es mit Pro.')} onOpen={() => store.closeSheet()} /></Sheet>;
  }
  switch (sheet.kind) {
    case 'entry': return <EntryEditor key={sheet.entryId ?? `new-${sheet.day}`} entryId={sheet.entryId} day={sheet.day} />;
    case 'project': return <ProjectEditor projectId={sheet.projectId} then={sheet.then} />;
    case 'export': return <ExportSheet projectId={sheet.projectId} />;
    case 'invoice': return <InvoiceSheet range={sheet.range} />;
    case 'reportPrint': return <ReportPrintSheet range={sheet.range} />;
    case 'spanEdit': return <SpanEdit sessionId={sheet.sessionId} range={sheet.range} mode={sheet.mode} />;
    case 'addDevice': return <AddDeviceSheet />;
    case 'search': return <SearchSheet />;
  }
}
